/**
 * LARIS Editions - shared data for layout variations
 * Short key points only (no headings, no paragraph text)
 */
export const LARIS_EDITIONS = [
  {
    id: "basic",
    label: "01",
    heading: "Basic Edition",
    img: "/assets/img/blog/BASIC.svg",
    detail: [
      "Core modules for daily operations",
      "Patient registration to test reporting",
      "Structured workflows and accurate data handling",
      "Intuitive, user-friendly interface design.",
    ],
  },
  {
    id: "advanced",
    label: "02",
    heading: "Advanced Edition",
    img: "/assets/img/blog/ADVANCED.svg",
    detail: [
      "Procurement and accounts management",
      "Purchasing, invoicing, financial management",
      "Budgeting, vendor management, expense tracking",
      "Mid-sized labs with complex requirements",
    ],
  },
  {
    id: "premium",
    label: "03",
    heading: "Premium Edition",
    img: "/assets/img/blog/PREMIUM.svg",
    detail: [
      "Inventory control and HR management",
      "Stock tracking, supply chain optimization",
      "Employee records, payroll, performance management",
      "Integrated website and patient portal",
    ],
  },
];
